export function axIsXMLCollection(x, sec) {
    return sec.AXXML.dPrototype.isPrototypeOf(x) ||
        sec.AXXMLList.dPrototype.isPrototypeOf(x);
}
